import { render, staticRenderFns } from "./applicationList.vue?vue&type=template&id=f88dc82a&scoped=true&"
import script from "./applicationList.vue?vue&type=script&lang=js&"
export * from "./applicationList.vue?vue&type=script&lang=js&"
import style0 from "./applicationList.vue?vue&type=style&index=0&id=f88dc82a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88dc82a",
  null
  
)

export default component.exports